import { useContext } from 'react';
import { AppDisclaimerContext } from 'src/contexts';

export const useAppDisclaimer = () => useContext(AppDisclaimerContext);
